module.exports = __webpack_public_path__ + "static/media/arrow-right.eb5f9e8c.svg";